import {createContext} from 'react'


export  const VisitContext = createContext({
    visit: {}
})